var map = {
	"./multiplier_1.png": 8492,
	"./multiplier_128.png": 35702,
	"./multiplier_128_win.png": 78161,
	"./multiplier_16.png": 98291,
	"./multiplier_16_win.png": 40708,
	"./multiplier_1_win.png": 13627,
	"./multiplier_2.png": 76967,
	"./multiplier_2_win.png": 59076,
	"./multiplier_32.png": 10606,
	"./multiplier_32_win.png": 1945,
	"./multiplier_4.png": 41745,
	"./multiplier_4_win.png": 63370,
	"./multiplier_64.png": 92239,
	"./multiplier_64_win.png": 19100,
	"./multiplier_8.png": 20941,
	"./multiplier_8_win.png": 65678
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 15642;